import { useAccountInfo, PageStep } from './hooks';
import { SelectItem } from './hooks/useUpdatePage';
import './style.scss';
import { PageLocationSP } from 'views/components/atoms/pageLocation';
import { Button } from 'views/components/atoms/button';
import { SendSMSTemplate } from 'views/components/templates/sendSMS';
import { Toast } from 'views/components/atoms/toast';
import { SearchSelect } from 'views/components/atoms/searchSelect';
import {
  CustomerInfoTemplate,
  DepositAccountTemplate,
  EmploymentTemplate,
  InvestmentInfoTemplate,
  RequestConfirmTemplate,
} from 'views/components/templates/establishes';
import { Guidances } from 'views/components/atoms/guidances';

export const AccountInfo = () => {
  const { pageStep, initislPageProps, authPageProps, updatePageProps, updateConfirmProps, toastProps } =
    useAccountInfo();
  return (
    <section className="accountSetting">
      <PageLocationSP />
      {pageStep === PageStep.INITIAL && (
        <div className="accountSetting_sms">
          <Guidances label="登録情報を参照・変更するには2段階認証が必要です" />
          <Button {...initislPageProps.sendSMSBtnProps} />
        </div>
      )}
      {pageStep === PageStep.AUTH && <SendSMSTemplate {...authPageProps} toastProps={toastProps} />}
      {pageStep === PageStep.UPDATE && (
        <form onSubmit={updatePageProps.executeConfirm}>
          <div className="accountSetting_select">
            <SearchSelect {...updatePageProps.selectProps} />
            <Button {...updatePageProps.updateBtnProps} />
          </div>
          <div className="accountSetting_form">
            {updatePageProps.selectProps.selectedOption === SelectItem.CustomerInfo && (
              <CustomerInfoTemplate {...updatePageProps.costomerInfoProps} />
            )}
            {updatePageProps.selectProps.selectedOption === SelectItem.DepositAccount && (
              <DepositAccountTemplate {...updatePageProps.depositAccountProps} />
            )}
            {updatePageProps.selectProps.selectedOption === SelectItem.Employment && (
              <EmploymentTemplate {...updatePageProps.employmentProps} />
            )}
            {updatePageProps.selectProps.selectedOption === SelectItem.InvestmentInfo && (
              <InvestmentInfoTemplate {...updatePageProps.investmentInfoProps} />
            )}
          </div>
        </form>
      )}
      {pageStep === PageStep.CONFIRM && <RequestConfirmTemplate {...updateConfirmProps} />}
      <Toast {...toastProps} />
    </section>
  );
};
